const slider_config_type = {
  1: {
    slidesPerView: 3,
    spaceBetween: 12,
    centerInsufficientSlides: true,
    breakpoints: {
      1: {
        slidesPerView: 1,
        spaceBetween: 9
      },
      350: {
        slidesPerView: 1.08052
      },
      500: {
        slidesPerView: 1.6
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 12
      }
    }
  },
  2: {
    slidesPerView: 1
  },
  3: {
    slidesPerView: 1,
  },
  4: {
    slidesPerView: 4,
    spaceBetween:12,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      1: {
        spaceBetween:8
      },
      768: {

        spaceBetween: 12
      }
    }
  }
};
class CustomSlider extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    this.index = this.dataset.index || 1;

    const isThumb = this.classList.contains('swiper-thumb');
    const noNavigation = this.hasAttribute('data-no-navigation') || isThumb;

    const nextEl = !noNavigation
      ? this.querySelector(".swiper-button-next") || this.closest('.shopify-section')?.querySelector(".swiper-button-next")
      : null;

    const prevEl = !noNavigation
      ? this.querySelector(".swiper-button-prev") || this.closest('.shopify-section')?.querySelector(".swiper-button-prev")
      : null;

    const navigation = nextEl && prevEl
      ? {
          navigation: {
            nextEl,
            prevEl,
          },
        }
      : {};

    this.config = {
      ...slider_config_type[this.index],
      ...navigation,
      observer: true,
      observeParents: true,
    };

    const effect = this.dataset.effect;
    if (effect && effect !== 'slide') {
      this.config.effect = effect;
      this.config.loop = true;
      if (effect === 'fade') {
        this.config.fadeEffect = { crossFade: true };
      } else if (effect === 'creative') {
        this.config.creativeEffect = {
          prev: { shadow: true, translate: [0, 0, -400] },
          next: { translate: ['100%', 0, 0] }
        };
      } else if (effect === 'coverflow') {
        this.config.coverflowEffect = { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: true };
      }
    }

    const autoplayDelay = this.dataset.autoplay;
    if (autoplayDelay) {
      this.config.autoplay = { delay: parseInt(autoplayDelay), disableOnInteraction: false };
      this.config.loop = true;
    }

    const paginationEl = this.querySelector('.swiper-pagination');
    if (paginationEl) {
      this.config.pagination = { el: paginationEl, clickable: true };
    }

    if (this.classList.contains('swiper-main-thumb')) {
      this.initMainWithThumbs();
      return;
    }

    this.swiper = new Swiper(this, this.config);
  }

  initMainWithThumbs() {
    const section = this.closest('.section-thumbnail-slider__wrap') || this.closest('.shopify-section');
    const thumbSlider = section?.querySelector('custom-slider.swiper-thumb');

    if (!thumbSlider) {
      this.swiper = new Swiper(this, this.config);
      return;
    }

    const init = () => {
      if (!thumbSlider.swiper) {
        requestAnimationFrame(init);
        return;
      }

      this.swiper = new Swiper(this, {
        ...this.config,
        thumbs: {
          swiper: thumbSlider.swiper,
          autoScrollOffset: 1,
        },
      });
    };

    init();
  }
}

customElements.define('custom-slider', CustomSlider);